import React, { useState, useMemo } from "react";
import "./A1ListSchedule.css";

const INITIAL_COUNT = 2;

export default function A1ListSchedule({ data }) {
  const [showAll, setShowAll] = useState(false);

  const parsedData = useMemo(() => {
    if (!data) return null;
    if (typeof data === "string") {
      try { return JSON.parse(data); } catch { return null; }
    }
    return data;
  }, [data]);

  if (!parsedData) return null;
  const { channels } = parsedData;
  const channelList = channels?.channelList || [];

  const visibleChannels = showAll ? channelList : channelList.slice(0, INITIAL_COUNT);

  return (
    <div className="a1-list-schedule">
      <div className="a1-list-schedule-cards">
        {visibleChannels.map((channel, index) => (
          <div className="a1-list-schedule-card" key={index}>
            <img
              className="a1-list-schedule-img"
              src={channel.imageLink}
              alt={channel.name}
              onError={(e) => (e.target.src = "")}
            />
            <div className="a1-list-schedule-info">
              <span className="a1-list-schedule-name">
                {channel.name} ({channel.language})
              </span>
              <span className="a1-list-schedule-ch">Ch. {channel.channelNo}</span>
            </div>
            <span className={`a1-list-schedule-badge ${channel.hd_SD === "HD" ? "a1-badge-hd" : "a1-badge-sd"}`}>
              {channel.hd_SD}
            </span>
          </div>
        ))}
      </div>
      {!showAll && channelList.length > INITIAL_COUNT && (
        <div className="a1-list-schedule-footer">
          <span className="a1-list-schedule-viewmore" onClick={() => setShowAll(true)}>
            View More
          </span>
        </div>
      )}
      {showAll && channelList.length > INITIAL_COUNT && (
        <div className="a1-list-schedule-footer">
          <span className="a1-list-schedule-viewmore" onClick={() => setShowAll(false)}>
            View Less
          </span>
        </div>
      )}
    </div>
  );
}
